function i(t, r) {
  return r ? typeof r == "string" ? " " + t + "--" + r : Array.isArray(r) ? r.reduce(function (n, u) {
    return n + i(t, u);
  }, "") : Object.keys(r).reduce(function (n, u) {
    return n + (r[u] ? i(t, u) : "");
  }, "") : "";
}
function f(t) {
  return function (r, n) {
    return r && typeof r != "string" && (n = r, r = ""), r = r ? t + "__" + r : t, "" + r + i(r, n);
  };
}
export { f as createBEM };
